<template>
    <div>
        <ChatListHeader :agentName="chatAgentName == 'SYSTEM' ? $t('chat.system') : chatAgentName" @closeChat="closeChat" @goBack="goBack" :arrowVisible="true" />
        <div style="height: 65vh; overflow-y: scroll;" ref="messageContainer">
            <div class="empty-txt" v-if="isEmptyChat">
                没有聊天记录了
            </div>
            <div v-else>
                <div v-for="(item, index) in messages" :key="index">
                    <ChatBubble v-if="!isMsgDisabled(item) && item.type != -1" :type="item.type" :message="item.message"
                        :isSent="item.sender == uid" :time="item.time" :isSystem="chatAgentName == 'SYSTEM'" />
                        <div class="agent-transfer" v-if="item.type == -1">{{item.message}}</div>
                </div>
            </div>
        </div>
        <div v-if="isToolbar">
            <ChatTools ref="toolbar" @sendMsg="sendMsg" :loading="loading" @uploadStarted="loading = true"
                @uploadError="loading = false" />
        </div>
    </div>
</template>

<script>
import ChatListHeader from './components/chatListHeader.vue';
import ChatBubble from './components/chatBubble.vue'
import ChatTools from './components/chatTools.vue'
import eventBus from '../../../assets/js/eventBus';
export default {
    name: "ChatPage",
    components: {
        ChatListHeader,
        ChatBubble,
        ChatTools
    },
    data() {
        return {
            messages: [],
            chatAgentId: "",
            isToolbar: false,
            selectedAgent: {},
            chatAgentName: "",
            uid: localStorage.getItem('uid'),
            receivedMsgs: [],
            loading: false,
            isEmptyChat: false
        }
    },
    beforeDestroy() {
        this.markAsRead()
    },
    created() {
        // Close the previous listeners
        eventBus.$off("onChatReceived");
        
        eventBus.$on("onChatReceived", (data) => {
            if (localStorage.getItem("chatPage") == 2 && !this.receivedMsgs.includes(data.order_id)) {
                this.receivedMsgs.push(data.order_id);

                if (data.receiver == this.chatAgentId || data.sender == this.chatAgentId) {
                    // Sort message list by time
					let messagesList = [ ...this.messages ]
					messagesList.push(data)
					messagesList.sort((a, b) => a.time - b.time)
					this.messages = messagesList;

                    this.isEmptyChat = false;

                    if (data.type == 0) {
                        this.scrollToBottom();
                    } else {
                        setTimeout(() => {
                            this.$nextTick(() => {
                                this.scrollToBottom();
                            });
                        }, 3000);
                    }
                    this.markAsRead()
                }
            }
        })

        // On message deleted
        eventBus.$on("msgDeleted", (data) => {
            if (localStorage.getItem("chatPage") == 2) {
                const msgIndex = this.messages.findIndex(item => item.order_id == data)
                if (msgIndex > -1) {
                    this.messages[msgIndex].status = 0;
                    this.checkIsEmpty()
                }
            }
        })
    },
    mounted() {
        this.chatAgentId = localStorage.getItem("chatAgentId");

        if (this.chatAgentId !== "SYSTEM") {
            this.isToolbar = true;
            this.markAsRead();
            let agentList = JSON.parse(localStorage.getItem("agent_list"));
            this.selectedAgent = agentList.find(m => m.number == this.chatAgentId);
            this.chatAgentName = this.selectedAgent.name;
            this.messages = this.selectedAgent.messages;
            this.checkIsEmpty()
        } else {
            eventBus.$emit('updateTotalCount');
            this.isToolbar = false;
            this.chatAgentName = "SYSTEM";
            const availableMessages = JSON.parse(localStorage.getItem('systemMessages'));
            this.messages = availableMessages;
            this.checkIsEmpty()
        }

        this.scrollToBottom();
    },
    methods: {
        closeChat() {
            this.$emit('closeChat');
        },
        goBack() {
            this.$emit('goBack');
        },
        markAsRead() {
            let that = this;
            that
                .$http({
                    url: "/app/Chat/readMsg",
                    method: "post",
                    data: {
                        user_id: localStorage.getItem('uid'),
                        sender: that.chatAgentId
                    },
                    chatUrl: true,
                    transformRequest: [(data) => JSON.stringify(data)]
                })
                .then(function (res) {
                    if (res.data.status == 200) {
                        that.setAgentCountZero()
                    } else {
                        that.$message.error(that.$t(res.data.msgId));
                    }
                });
        },
        setAgentCountZero() {
            let agentList = JSON.parse(localStorage.getItem("agent_list"));
            agentList.forEach(element => {
                if (element.number == this.chatAgentId) {
                    element.count = 0;
                    element.unreadMsgIds = []
                }
            });
            localStorage.setItem('agent_list', JSON.stringify(agentList));
            eventBus.$emit('updateTotalCount');
        },
        scrollToBottom() {
            this.$nextTick(() => {
                const messageContainer = this.$refs.messageContainer;
                messageContainer.scrollTop = messageContainer.scrollHeight;
            });
        },
        sendMsg(message, type) {
            if (message.trim() == "") {
                this.$message.error(this.$t("chat.messageEmpty"))
                return;
            }
            this.loading = true;
            const sendObj = {
                message: message,
                sender: localStorage.getItem('uid'),
                receiver: this.chatAgentId,
                type: type,
                sender_name: localStorage.getItem("username"),
                receiver_name: this.chatAgentName,
                sender_account: localStorage.getItem("user_number"),
                receiver_account: this.chatAgentId
            }

            let that = this;
            that
                .$http({
                    url: "/app/Chat/send",
                    method: "post",
                    data: sendObj,
                    chatUrl: true,
                    transformRequest: [(data) => JSON.stringify(data)]
                })
                .then(function (res) {
                    if (res.data.status == 200) {
                        that.setMessageList(res.data.data);
                        that.$refs.toolbar.clearTextArea()

                        if (type == 0) {
                            this.scrollToBottom();
                        } else {
                            setTimeout(() => {
                                this.$nextTick(() => {
                                    this.scrollToBottom();
                                });
                            }, 3000);
                        }
                    } else {
                        that.$refs.toolbar.clearTextArea()
                        that.$message.error(that.$t("chat.messageFailed"));
                        this.loading = false
                    }
                }).catch(() => {
                    this.loading = false;
                })
        },
        setMessageList(messageItem) {
            let agentList = JSON.parse(localStorage.getItem('agent_list'));
            agentList.forEach(element => {
                if (element.number == messageItem.receiver || element.number == messageItem.sender) {
                    element.messages.push(messageItem);
                    element.last_msg = messageItem;
                }
            });

            let orderedAgents = []
            if (agentList.length) {
                orderedAgents = agentList.sort((a, b) => {
                    const a_lastMsg = a.messages[a.messages.length - 1];
                    const b_lastMsg = b.messages[b.messages.length - 1];

                    if (b_lastMsg && a_lastMsg) {
                        return b_lastMsg.time - a_lastMsg.time;
                    } else if (!b_lastMsg && !a_lastMsg) {
                        return 0;
                    } else if (b_lastMsg && !a_lastMsg) {
                        return 1;
                    } else if (a_lastMsg && !b_lastMsg) {
                        return -1;
                    }
                })
            }
            localStorage.setItem('agent_list', JSON.stringify(orderedAgents));
            this.messages.push(messageItem)
            this.isEmptyChat = false;

            this.scrollToBottom()
            this.loading = false;
        },
        isMsgDisabled(msg) {
            const deletedMsgs = localStorage.getItem('deletedMsgs') ? JSON.parse(localStorage.getItem('deletedMsgs')) : []
            if (deletedMsgs.length) {
                const deleted = deletedMsgs.findIndex(item => item == msg.order_id)
                return msg.status == 0 || deleted > -1 || msg.type == -100
            } else {
                return msg.status == 0 || msg.type == -100
            }
        },
        checkIsEmpty() {
            this.isEmptyChat = this.messages.length == 0 || this.messages.every(item => this.isMsgDisabled(item));
        }
    }
}
</script>

<style scoped>
.empty-txt {
    color: rgb(187, 184, 184);
    font-size: 15px;
    text-align: center;
    padding-top: 30px;
}
.agent-transfer{
    background-color: #adb2b7; 
    padding: 3px 3px; 
    border-radius: 3px;
    margin: 10px;
    align-items: stretch;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/module/chat/chat.vue